export default {"src":"/_next/static/media/6-icon.be2bb70e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};